import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const preventiveServicesSeoMetaData: SeoMetaData[] = [
  {
    path: '/preventive-services',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/preventive-services/available',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/preventive-services/upcoming',
    seo: {
      en: {
        title: 'My preventive services | Medicare',
        description: ''
      },
      es: {
        title: 'Mis servicios preventivos | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: Component.PreventiveServices
}))
